<template>
  <div class="pointApp" :style="'min-height:'+curHeight+'px;background:url('+baseUrl+detail.img+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="con">
      <h2>{{detail.title}}</h2>
      <input type="text" @input="codeYzm" v-model="phone" placeholder="请输入手机号码" />
      <div class="code">
        <input type="text" v-model="code" placeholder="请输入验证码" />
        <span @click="send" :style="pat ? 'color:#000' : ''">{{sendSns}}</span>
      </div>
      
      <button @click="receive">立即领取</button>
      <a id="chooseImage">联系客服</a>
    </div>
    <el-dialog
      title="是否立即购买"
      :visible.sync="payment"
      width="30%" top="50%" :show-close="false" :close-on-click-modal="false">
      <span style="padding-bottom:15px;display:block;">积分劵领取成功，快去消费吧</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toPush(detail.cate_id,'product')">立即去消费</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        sendSns:'获取验证码',
        pat:false,
        flag: false,
        code:'',
        phone:'',
        detail:[],
        payment:false
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        var id = this.$route.query.id;
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/point?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getDetail();
        this.getQquey();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },



      getQquey:function(){
        var that = this;
        var id = this.$route.query.id;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'previewImage'
            ]
          });
          wx.ready(function() {
            wx.updateTimelineShareData({
              title: that.detail.title, // 分享标题
              link: 'http://user.4008005216.com/main/point?id='+id,
              imgUrl: that.baseUrl+that.detail.img, // 分享图标
              success: function () {
              // 用户点击了分享后执行的回调函数
              }
            });

            $('#chooseImage').on('click', function() {
              wx.previewImage({
                current: 'http://admin.4008005216.com/upload/20210724/43cdef67aef161384a1bff2e91e2f5dc.jpg', // 当前显示图片的http链接
                urls: ['http://admin.4008005216.com/upload/20210724/43cdef67aef161384a1bff2e91e2f5dc.jpg'] // 需要预览的图片http链接列表
              });
            })
            wx.updateAppMessageShareData({
              title: that.detail.title, // 分享标题
              desc: that.detail.content, // 分享描述
              link: 'http://user.4008005216.com/main/point?id='+id, 
              imgUrl: that.baseUrl+that.detail.img, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
              }
            });


          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },

      codeYzm:function(){
        let reg = /^1[0-9]{10}$/;
        var phone = this.phone;
        if (reg.test(phone)){
          this.pat = true
        }else{
          this.pat = false
        }
      },
      send:function(){
        if(!this.pat || this.flag){
          return false;
        }
        if(this.phone == ''){
          alert('请输入手机号码');
          return false;
        }
        let reg = /^1[0-9]{10}$/
        if(!reg.test(this.phone)){
          alert('请输入正确的手机号码');
          return false;
        }
        var i = 60
        let time = setInterval(() => {
          i--
          if(i < 1){
            this.sendSns = '获取验证码';
            clearInterval(time)
            this.pat = false;
            this.flag = false
            return false;
          }
          this.sendSns = i+'秒后重试';
          this.flag = true
          }, 1000)

        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/product/SendSms',
          params:{
            phone:that.phone
          }
        }).then(function(response){
          if(response.data.status == 200){

          }else{
            alert('短信下发失败');
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/appoint',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      receive:function(){
        var that = this;
        var id = this.$route.query.id;

        if(that.phone == ''){
          alert('请输入手机号');
          return false;
        }
        if(that.code == ''){
          alert('请输入验证码');
          return false;
        }
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/setAppoint',
          params:{
            phone:that.phone,
            code:that.code,
            id:that.detail.id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.payment = true;
          }else{
            alert(response.data.message)
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:80% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .pointApp{
    max-width:640px;
    background:#f5f5f5;
    margin:0 auto;
    background-size:100% 100% !important;
  }

  .pointApp .con{
    position: fixed;
    bottom: 10%;
    left: 5%;
    width:90%;
    background:#fff;
    height:260px;
    border-radius:8px;
  }
  .pointApp .con h2{
    font-size:16px;
    letter-spacing:2px;
    text-align:center;
    padding:20px 0 20px 0
  }
  .pointApp .con input{
    display:block;
    width:75%;
    margin:0px auto 15px auto;
    height:40px;
    border:solid #f1f1f1 1px;
    border-radius:40px;
    padding-left:5%;
    font-size:18px
  }
  .pointApp .con .code{
    position:relative;
  }
  .pointApp .con .code span{
    position: absolute;
    right:0;
    top:0px;
    height:42px;
    background:#f1f1f1;
    right:10%;
    border-top-right-radius:40px;
    border-bottom-right-radius:40px;
    line-height:42px;
    padding:0 10px;
    font-size:15px;
    color:#555
  }
  .pointApp .con button{
    display:block;
    width:65%;
    margin:0px auto;
    height:40px;
    border:none;
    border-radius:40px;
    color:#fff;
    background:rgb(234,51,35);
    font-size:16px;
    margin-top:20px
  }
  #chooseImage{
    display:block;
    width:100%;
    text-align:center;
    font-size:14px;
    color:#666;
    padding-top:10px;
  }
</style>